export enum BTCCommissionTypes {
    PURCHASES = 'Purchases',
    PROFIT_MATCHING = 'Profit Matching',
    MISSED_PROFIT_MATCHING = 'Missed Profit Matching',
}
